export var getParamFromUrl = function (param, url) {
    if (!url.includes('?')) {
        return null;
    }
    var params = new URLSearchParams(url.split('?')[1]);
    return params.get(param);
};
export var mapDataToFormData = function (data, formData) {
    if (formData === void 0) { formData = null; }
    var fData = formData !== null && formData !== void 0 ? formData : new FormData();
    Object.keys(data).forEach(function (key) {
        appendObjectToFormData(fData, data[key], key);
    });
    return fData;
};
var appendObjectToFormData = function (formData, data, parentKey) {
    if (parentKey === void 0) { parentKey = ''; }
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach(function (key) {
            appendObjectToFormData(formData, data[key], parentKey ? "".concat(parentKey, "[").concat(key, "]") : key);
        });
    }
    else {
        var value = data == null ? '' : data;
        formData.append(parentKey, value);
    }
};
export var sanitizeColumnSelector = function (name) {
    return name.replace(/\./g, '\\.');
};
export var withCooldown = function (callback, delay) {
    if (delay === void 0) { delay = 1000; }
    var isCoolingDown = false;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (isCoolingDown)
            return;
        isCoolingDown = true;
        callback.apply(this, args);
        setTimeout(function () {
            isCoolingDown = false;
        }, delay);
    };
};
